import {Link} from 'react-router-dom';

const NotFound = () => {
    return (
        <div className='container'>
            <div className='pt-5 mt-5'>
                <div className="text-center">
                    <h2>Page not found</h2>
                    <Link to='/'>Home</Link>
                </div>
            </div>
        </div>
    )
}

export default NotFound
